import Auth from '@/helpers/authorizations'
import Management from '@/layouts/Management'

export default {
  path: '/cars',
  component: Management,
  redirect: '/cars/list',
  children: [
    // 列表页
    {
      path: 'list',
      component: () => import('@/views/cars/List'),
      meta: {
        auth: Auth.listCars
      }
    },
    // 新增
    {
      path: 'new',
      component: () => import('@/views/cars/New'),
      meta: {
        auth: Auth.createCar
      }
    },
    // 编辑
    {
      path: ':id/edit',
      component: () => import('@/views/cars/Edit'),
      meta: {
        auth: Auth.updateCar
      }
    },
    // 详情
    {
      path: ':id',
      component: () => import('@/views/cars/DetailLayout'),
      meta: {
        auth: Auth.showCar
      },
      children: [
        // 基本信息
        {
          path: 'detail',
          component: () => import('@/views/cars/details/Detail'),
          meta: {
            tabName: 'detail', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.showCar
          }
        },
        {
          path: 'orders',
          component: () => import('@/views/cars/details/Orders'),
          meta: {
            tabName: 'orders', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listOrders
          }
        },
        {
          path: 'vin_records',
          component: () => import('@/views/cars/details/VinRecords'),
          meta: {
            tabName: 'vin_records', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listVinRecords
          }
        },
        {
          path: 'inserting_gun_start_records',
          component: () => import('@/views/cars/details/InsertingGunStartRecords'),
          meta: {
            tabName: 'inserting_gun_start_records', // 标签页的标签名，用于确认活动的标签页
            auth: Auth.listInsertingGunStartRecords
          }
        }
      ]
    }
  ]
}
